"use client";

import { usePathname } from "next/navigation";
import InstancePage from "@/components/instance/InstancePage";
import DashboardContent from "@/components/DashboardContent";
import LocalServicesPage from "@/components/local-services/LocalServicesPage";

/**
 * Main page component with client-side routing.
 * Fixes React Error #310 by ensuring hooks are called consistently.
 * The routing decision happens before any conditional hooks are called.
 */
export default function Page() {
  const pathname = usePathname() || "/";
  
  // Client-side routing for SPA behavior with static export
  const parts = pathname.split("/").filter(Boolean);
  
  // Handle /instance/<uuid> routes
  if (parts[0] === "instance" && parts[1]) {
    return <InstancePage uuid={parts[1]} />;
  }
  
  // Handle /local-services route
  if (parts[0] === "local-services") {
    return <LocalServicesPage />;
  }
  
  // Default dashboard view
  return <DashboardContent />;
}
